/** CoStar.Api.AptsFeatures.ViewModels.Common.FeatureRestrictionType */
export var FeatureRestrictionType;
(function (FeatureRestrictionType) {
    FeatureRestrictionType[FeatureRestrictionType["None"] = 0] = "None";
    FeatureRestrictionType[FeatureRestrictionType["FullAccess"] = 1] = "FullAccess";
    FeatureRestrictionType[FeatureRestrictionType["UserAccess"] = 2] = "UserAccess";
    FeatureRestrictionType[FeatureRestrictionType["LocationIdAccess"] = 3] = "LocationIdAccess";
    FeatureRestrictionType[FeatureRestrictionType["GeoAccess"] = 4] = "GeoAccess";
    FeatureRestrictionType[FeatureRestrictionType["PostalCodeAccess"] = 5] = "PostalCodeAccess";
    FeatureRestrictionType[FeatureRestrictionType["ListingAccess"] = 6] = "ListingAccess";
})(FeatureRestrictionType || (FeatureRestrictionType = {}));
/** CoStar.Api.AptsFeatures.ViewModels.Common.BrandType */
export var BrandType;
(function (BrandType) {
    BrandType[BrandType["None"] = 0] = "None";
    BrandType[BrandType["Apartments"] = 1] = "Apartments";
    BrandType[BrandType["ApartmentFinder"] = 2] = "ApartmentFinder";
    BrandType[BrandType["ApartmentHomeLiving"] = 3] = "ApartmentHomeLiving";
    BrandType[BrandType["FinderSite"] = 4] = "FinderSite";
    BrandType[BrandType["Move"] = 5] = "Move";
})(BrandType || (BrandType = {}));
